interface Actions {
  type: string;
  payload: boolean | number | any;
}

interface InitialStateProp {
  isIntentTopicsConfigured: boolean;
}

export const SET_IS_INTENT_TOPICS_CONFIGURED = 'SET_IS_INTENT_TOPICS_CONFIGURED';

export const setIsIntentTopicsConfigured = (value: boolean) => ({
  type: SET_IS_INTENT_TOPICS_CONFIGURED,
  payload: value,
});

const initialState = {
  isIntentTopicsConfigured: false,
};

const configuredIntentTopicsReducer = (state = initialState, actions: Actions) => {
  switch (actions.type) {
    case SET_IS_INTENT_TOPICS_CONFIGURED:
      return { ...state, isIntentTopicsConfigured: actions.payload };
    default:
      return state;
  }
};

export default configuredIntentTopicsReducer;
